/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AutosavePalAuthSubmission200ResponseData } from './AutosavePalAuthSubmission200ResponseData';
import {
    AutosavePalAuthSubmission200ResponseDataFromJSON,
    AutosavePalAuthSubmission200ResponseDataFromJSONTyped,
    AutosavePalAuthSubmission200ResponseDataToJSON,
    AutosavePalAuthSubmission200ResponseDataToJSONTyped,
} from './AutosavePalAuthSubmission200ResponseData';

/**
 * 
 * @export
 * @interface AutosavePalAuthSubmission200Response
 */
export interface AutosavePalAuthSubmission200Response {
    /**
     * 
     */
    data?: AutosavePalAuthSubmission200ResponseData;
}

/**
 * Check if a given object implements the AutosavePalAuthSubmission200Response interface.
 */
export function instanceOfAutosavePalAuthSubmission200Response(value: object): value is AutosavePalAuthSubmission200Response {
    return true;
}

export function AutosavePalAuthSubmission200ResponseFromJSON(json: any): AutosavePalAuthSubmission200Response {
    return AutosavePalAuthSubmission200ResponseFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmission200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : AutosavePalAuthSubmission200ResponseDataFromJSON(json['data']),
    };
}

export function AutosavePalAuthSubmission200ResponseToJSON(json: any): AutosavePalAuthSubmission200Response {
    return AutosavePalAuthSubmission200ResponseToJSONTyped(json, false);
}

export function AutosavePalAuthSubmission200ResponseToJSONTyped(value?: AutosavePalAuthSubmission200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': AutosavePalAuthSubmission200ResponseDataToJSON(value['data']),
    };
}

